import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-datatable-title',
  templateUrl: './datatable-title.component.html',
  styleUrls: ['./datatable-title.component.scss']
})
export class DatatableTitleComponent {

  @Input() count: number = 0;
  @Input() title: string = '';
  @Input() countTitle: string = '';
  @Input() isShowCount=true;
  
}
